import { render, staticRenderFns } from "./createResult.vue?vue&type=template&id=0b125758&scoped=true&"
import script from "./createResult.vue?vue&type=script&lang=js&"
export * from "./createResult.vue?vue&type=script&lang=js&"
import style0 from "./createResult.vue?vue&type=style&index=0&lang=css&"
import style1 from "./createResult.vue?vue&type=style&index=1&id=0b125758&lang=less&scoped=true&"
import style2 from "./createResult.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b125758",
  null
  
)

component.options.__file = "createResult.vue"
export default component.exports